module.exports = __webpack_public_path__ + "assets/apple-icon-57x57.6feecb95.png";